/* unplugin-vue-components disabled */import script from "./RTU.vue?vue&type=script&lang=ts&setup=true"
export * from "./RTU.vue?vue&type=script&lang=ts&setup=true"

import "./RTU.vue?vue&type=style&index=0&id=79e21116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e21116"]])

export default __exports__